export default {
      id: "télécharger-usage",
      viewBox: "0 0 50 50",
      url: "../dist/images/" + "sprite.svg#télécharger-usage",
      toString: function () {
        return this.url;
      }
    }